import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User clicked "Change person option"',
  name: 'clicked_change_person_option',
  params: [
    {
      description: 'The id of the face',
      name: 'face_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Location of event',
      name: 'location',
      required: true,
      type: 'enum',
      values: ['image-preview', 'people-tab'],
    },
  ],
};

export default META;
